import { ScrollArea as ScrollAreaMantine } from '@mantine/core'
import styled from 'styled-components'

export const ScrollArea = styled(ScrollAreaMantine)`
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);

  .mantine-ScrollArea-thumb {
    background-color: ${({ theme }) => theme.cor22} !important;
  }

  .mantine-ScrollArea-scrollbar {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }

  .mantine-ScrollArea-viewport {
    padding-top: 10px;
    padding-bottom: 10px;
    mask-image: linear-gradient(
      to bottom,
      transparent,
      black 10px,
      black calc(100% - 10px),
      transparent
    );
  }
`